import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { ConvertToJSONService } from './convert-to-json.service';
const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
@Injectable({
  providedIn: 'root'
})
export class DashboardNewService {
  ServerUrl = environment.ServerUrl;
  constructor(
    private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private ConvertToJSON: ConvertToJSONService
  ) { }
  GetToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return tokenOption;
  }
  GetNFOSchemeList(formData, method): Observable<any> {
    const url = `${this.ServerUrl}/api/ExploreFund/${method}`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetIPONCDSchemeList(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/IPOBid/GetIPOData`;
    return this.http.post<any>(url, formData, this.GetToken());
  }
  GetSGBSchemeList(): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/SGBBond/GETSGBBondDetails`;
    return this.http.get<any>(DataUrl, this.GetToken()).pipe();
  }
  GetFDSchemeList(): Observable<any> {
    const url = `${this.ServerUrl}/api/FdCompanyDetails/GetFdCompanyDetals`;
    return this.http.get<any>(url, this.GetToken()).pipe();
  }
  GetBannerList(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/DashBoardBanner/GetAllDashBoardBannerData`;
    return this.http.post<any>(url, formData, this.GetToken());
  }
  GetTotalClients(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/CLientDashboard/CheckClientCount`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetTopmostData(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/CLientDashboard/GetDashboardTopMostData`;
    let result = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, result, this.GetToken());
  }
  GetRecentTransactionData(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/CLientDashboard/CheckRecentTransactions`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
   GetTopMostTransactionData(formData): Observable<any> {   //om start
    debugger
    const url = `${this.ServerUrl}/api/CLientDashboard/CheckTopMostTransactions`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken());
  }  //om end
  GetReminderData(formData, para): Observable<any> {
    let url = ``;
    switch (para) {
      case 'birthdays':
        url = `${this.ServerUrl}/api/CLientDashboard/GetClientBirthdays`;
        break;
      case 'fd_maturity':
        url = `${this.ServerUrl}/api/CLientDashboard/CheckClientCount`;
        break;
      default:
        url = `${this.ServerUrl}/api/CLientDashboard/GetDashboardSIPData`;
        break
    }
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  //Added By Ravi Vaghela
  GetBusinessSnapshotData(data, para): Observable<any> {
    let url = ``;
    switch (para) {
      case 'ipo':
        url = `${this.ServerUrl}/api/IFDDashboardIPO/GetDashboardIPOData`;
        break;
      case 'ncd':
        url = `${this.ServerUrl}/api/IFDDashboardNCD/GetDashboardNCDData`;
        break;
      case 'sgb':
        url = `${this.ServerUrl}/api/IFDDashboard/GetDashboardSGBData`;
        break;
      case 'mld-nld':
        url = `${this.ServerUrl}/api/RMDashboard/GetProductSummary`;
        break;
    }
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetBusinessSnapshotData_Client(data, para): Observable<any> {
    let url = ``;
    switch (para) {
      case 'sip':
        url = `${this.ServerUrl}/api/ClientDashboardSIP/GetClientSIPData`;
        break;
      case 'ipo':
        url = `${this.ServerUrl}/api/ClientDashboardIPO/GetClientIPOData`;
        break;
      case 'ncd':
        url = `${this.ServerUrl}/api/ClientDashboardNCD/GetClientNCDData`;
        break;
      case 'sgb':
        url = `${this.ServerUrl}/api/ClientDashboardSGB/GetClientSGBData`;
        break;
    }
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetOverAllData(data, para): Observable<any> {
    let url = ``;
    switch (para) {
      case 'product':
        url = `${this.ServerUrl}/api/IFDOverAllProductWise/GetProductWiseData`;
        break;
      case 'asset':
        url = `${this.ServerUrl}/api/IFDOverAllAssetWise/GetAssetWiseData`;
        break;
    }
    // return this.http.post<any>(url, data, this.GetToken());
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetMFData(data, para): Observable<any> {
    let url = ``;
    switch (para) {
      case 'mf-amc':
        url = `${this.ServerUrl}/api/IFDMFAmcWise/GetIFDMFAmcWiseData`;
        break;
      case 'mf-asset':
        url = `${this.ServerUrl}/api/IFDMFAssetWise/GetIFDMFAssetWiseData`;
        break;
      case '':
        url = `${this.ServerUrl}/api/IFDMFAssetWise/GetIFDMFSubAssetWiseData`;
        break;
    }
    // return this.http.post<any>(url, data, this.GetToken());
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetMFData_Sip_IFD(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDSIPInstallment/GetSIPInstallmentData`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetMFData_Volume_IFD(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDMFVolume/GetMFVolumeData`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetMFData_Mobilization_IFD(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDMFVolume/GetMFVolumeData`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetMFData_AUM_IFD(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDMFAUM/GetMFAUMData`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetMFData_Sip_Book_IFD(data): Observable<any> {
    console.clear()
    let url = `${this.ServerUrl}/api/IFDSIPBook/GetSIPBookData`;
    console.warn("url",url)
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    console.warn("request",req_str)
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetPMSData(data, para): Observable<any> {
    let url = ``;
    switch (para) {
      case 'pms-aum':
        url = `${this.ServerUrl}/api/IFDPMSAUM/GetIFDPMSAUMData`;
        break;
    }
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetPMSData_TrendAUM_IFD(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDPMSVolume/GetPMSVolumeData`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetAIFData(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDAIFAUM/GetIFDAIFAUMData`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetAIFData_Mobilization_IFD(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDAIFVolume/GetAIFVolumeData`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetFIData(data, para): Observable<any> {
    let url = ``;
    switch (para) {
      case 'fi-aum':
        url = `${this.ServerUrl}/api/IFDFIAUM/GetIFDFIAUMData`;
        break;
    }
    return this.http.post<any>(url, data, this.GetToken());
  }
  GetFDData(data, para): Observable<any> {
    let url = ``;
    switch (para) {
      case 'fd-aum':
        url = `${this.ServerUrl}/api/IFDFDAUM/GetIFDFDAUMData`;
        break;
    }
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetFDData_Mobilization_IFD(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDFDVolume/GetFDVolumeData`;

    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetFDData_Renewals_IFD(data): Observable<any> {
    let url = `${this.ServerUrl}/api/IFDFDRenewals/IFDFDRenewalsData`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(data)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  GetMFData_Client(clientId, Employee, subBrokerId, LoginInUserId, Schemecode, AMCCode, AssetType, AsOnDate, FolioNo): Observable<any> {
    Employee = 0;
    let url = `${this.ServerUrl}/api/PortfolioBreakdown/Details_DashBoard`; //Details_JM //Details_DashBoard
    const QueryString = `CON_STR=MF&TRANS_TYPE=Client&ClientBasicInfoId=${clientId}&EMPLOYEE_CODE=${Employee}&SUB_BROKER_CODE=${subBrokerId}&LogInUserID_Code=${LoginInUserId}&SchemeCode=${Schemecode}&AMCCode=${AMCCode}&FolioNumber=${FolioNo}&AssetType=${AssetType}&FromDate=01-01-1901&EndDate=${AsOnDate}`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken());
  }
  GetFDData_Allocation_Client(data): Observable<any> {
    let url = `${this.ServerUrl}/api/ClientFDPortFolioDetails/GetClientFDPortFolioDetails`;
    const tokenOption = this.GetToken();
    const body = { data: this.EncrdecrService.setEncr(data) };
    return this.http.post<any>(url, body, tokenOption).pipe();
    // return this.http.post<any>(url, data, this.GetToken());
  }
  GetAIFData_Client(data, todayDate): Observable<any> {
    const QueryString = `LogInUserID_Code=0|0&USER_TYPE=3&Role_ID=0&EndDate=${todayDate}&TRANS_TYPE=CLIENT_ID`;
    let url = `${this.ServerUrl}/api/AIFLedgerRepor?${QueryString}`;
    return this.http.post<any>(url, data, this.GetToken());
  }
  GetOpportunitiesCount(): Observable<any> {
    let url = `${this.ServerUrl}/api/GetDashBoardCount/GetDashBoardCount `;
    return this.http.get<any>(url, this.GetToken());
  }
  GetIFDsData_IFD(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/RMDashboard/GetIFDSnapshot`;
    let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, this.GetToken());
  }
  GetClientsData_IFD(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/RMDashboard/GetClientSnapshot`;
    // return this.http.post<any>(url, formData, this.GetToken());
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetAUAData_IFD(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/RMDashboard/GetMFSummary`;
    // return this.http.post<any>(url, formData, this.GetToken());
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  //Added by Saddam
  GetNewsLineData(data): Observable<any> {
    let url = `${this.ServerUrl}/api/NewsLineData/Details`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption);
  }

  GetInsuranceURL(data): Observable<any> {
    let url = `${this.ServerUrl}/api/InsuranceURL/GetURL`;
    const tokenOption = this.GetToken();
    let req_str = JSON.stringify(data);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, tokenOption);
  }

  GetINSPolicyData(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/IFDDashboard/GetINSPolicyData`;
    let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, this.GetToken());
  }
  GetINSPremiumTrends(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/IFDDashboard/GetINSPremiumTrend_Data`;
    let req_str = JSON.stringify(formData);
    const body = { data: this.EncrdecrService.setEncr(req_str) };
    return this.http.post<any>(url, body, this.GetToken());
  }

  //// Added by devid 18072024 For MFCentral Started
  GetTransSummaryHoldingDetails(data: any): Observable<any> {
    debugger
    const url = `${this.ServerUrl}/api/MFCentral/getTransSummHolddetails_MFCentral`;
    return this.http.post<any>(url, data, this.GetToken());
  }

  getClientContactData(data: any): Observable<any> {
    debugger
    const url = `${this.ServerUrl}/api/MFCentral/getClientContactData`;
    return this.http.post<any>(url, data, this.GetToken());
  }

  //Get Request Hit Count Check MF Central  
  GetReqHitCountCheckDet(data: any): Observable<any> {
    debugger
    const url = `${this.ServerUrl}/api/MFCentral/getRequestCountMFCentral`;
    return this.http.post<any>(url, data, this.GetToken());
  }

  //Send OTP MF Cental API Call   
  sendOTPMFCentral(data: any): Observable<any> {
    debugger
    const url = `${this.ServerUrl}/api/MFCentral/OTPSendMFCentral`;
    return this.http.post<any>(url, data, this.GetToken());
  }

  //Verify OTP MF Cental API Call
  VerifyOTPMFCentral(data: any): Observable<any> {
    debugger
    const url = `${this.ServerUrl}/api/MFCentral/VerifyOTPMFCentral`;
    return this.http.post<any>(url, data, this.GetToken());
  }

  //Get CAS Statement Detailed MF Central API Call
  CASStateDetailedMFC(data: any): Observable<any> {
    debugger
    const url = `${this.ServerUrl}/api/MFCentral/getCASStatementDetailedAPI`;
    return this.http.post<any>(url, data, this.GetToken());
  }

   //Get CAS Statement Transcation Details Show MF Central API Call
   GetTransDetailsMFCentral(data: any): Observable<any> {
    debugger
    const url = `${this.ServerUrl}/api/MFCentral/getTranscationDetails_MFCentral`;
    return this.http.post<any>(url, data, this.GetToken());
  }

  //// End by devid 18072024 For MFCentral Started
}
